import dataGenerationUtils from "../utils/data-generation.utils";
import dataHandlingUtils from "../utils/data-handling.utils";
import datetimeUtils from "../utils/datetime.utils";
import uiInteractionUtils from "../utils/ui-interaction.utils";
import utilityUtils from "../utils/utility.utils";

export default {
  ...datetimeUtils,
  ...utilityUtils,
  ...dataGenerationUtils,
  ...dataHandlingUtils,
  ...uiInteractionUtils,
};
